module.exports = __webpack_public_path__ + "static/media/img_mausoleo.8769ec9d.jpg";